module.exports = __webpack_public_path__ + "img/sp_04.2cf538ba.png";